// extracted by mini-css-extract-plugin
export default {"iconWrapper":"GreenLightningIcon_iconWrapper__seU2K","icon":"GreenLightningIcon_icon__weZqx","tooltip":"GreenLightningIcon_tooltip__ap+PR"};